export enum EstadosApiRequestEnum {
  cargando = 'cargando',
  inactivo = 'inactivo',
  exitoso = 'exitoso',
  huboError = 'huboError',
}
